'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _usageTrackerCore = require('usage-tracker-core');

var _storageKeys = require('usage-tracker-core/storageKeys');

var _cookieHelper = require('./helpers/cookieHelper');

var _langHelper = require('./helpers/langHelper');

var _sendBeacon = require('./helpers/sendBeacon');

var _sendBeacon2 = _interopRequireDefault(_sendBeacon);

var _reportError = require('./helpers/reportError');

var _reportError2 = _interopRequireDefault(_reportError);

var _tempStorage = require('./containers/tempStorage');

var tempStorage = _interopRequireWildcard(_tempStorage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasBeaconSupport = navigator && typeof navigator.sendBeacon === 'function';
var suffix = _enviro2.default.getShort() === 'qa' ? 'qa' : '';
var origin = 'https://app.hubspot' + suffix + '.com';
var path = '/usage-logging/v1/log/hublytics-multi/no-auth';
var reportNetworkError = function reportNetworkError(err) {
  return (0, _reportError2.default)(err, {
    fingerprint: ['usage-tracker-js', 'network']
  });
};
var getDebug = function getDebug() {
  return _enviro2.default.debug(_storageKeys.debugKey);
};
var getTrackerHstc = function getTrackerHstc() {
  return new Promise(function (resolve) {
    /* eslint-disable */
    var interval = void 0;
    var timeout = void 0;
    interval = setInterval(function () {
      var hstc = (0, _cookieHelper.getHstc)();
      if (hstc) {
        clearTimeout(timeout);
        clearInterval(interval);
        resolve(hstc);
      }
    }, 100);
    timeout = setTimeout(function () {
      if (!(0, _cookieHelper.getHstc)()) {
        clearInterval(interval);
        if (_enviro2.default.debug(_storageKeys.debugKey) && console && typeof console.warn === 'function') {
          console.warn('Could not get tracker hstc after 8 seconds');
        }
        resolve(null);
      }
    }, 8000);
  });
};

var PublicTrackingClient = (0, _usageTrackerCore.createClient)({
  clientName: 'public',
  getDebug: getDebug,
  getEmail: function getEmail() {
    return null;
  },
  getHubId: function getHubId() {
    return null;
  },
  getHstc: getTrackerHstc,
  getLang: function getLang() {
    return _langHelper.defaultLanguage;
  },
  getTempStorage: tempStorage.get,
  setTempStorage: tempStorage.set,
  logError: function logError(err) {
    if (getDebug()) {
      console.error(err);
    }
  },
  reportError: _reportError2.default,
  send: function send(_ref) {
    var events = _ref.events,
        query = _ref.query,
        isBeforeUnload = _ref.isBeforeUnload;

    var endpoint = path + '?' + query;
    var data = events;
    var sendXhr = function sendXhr() {
      var promise = _noAuthApiClient2.default.post(endpoint, { data: data }).catch(reportNetworkError);

      if (promise && typeof promise.done === 'function') {
        promise.done();
      }
    };

    if (isBeforeUnload && hasBeaconSupport) {
      (0, _sendBeacon2.default)('' + origin + endpoint, data, sendXhr);
    } else {
      sendXhr();
    }
  }
});

exports.default = PublicTrackingClient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-public/static-1.281/js/PublicTrackingClient.js
// module id = 619
// module chunks = 177